import { ReportsListDelegate } from '../../../services/DataDelegate/ReportsDelegate/reports.list.delegate';

export namespace ReportsStates {
    export function reportsStatesFactory() {
        const reports = {
            list: { timestamp: new Date(), data: {}, total: 100, currentPage: 1 },
            isFetching: false
        };
        return reports;
    }

    export function mutations() {
        return {
            updateReports(state: any) {
                const data: any = new ReportsListDelegate().Data;
                state.reports.list.data = data;
                state.reports.list.timestamp = new Date();
            },
            reportsStartFetching(state: any) {
                state.reports.isFetching = true;
            },
            reportsEndFetching(state: any) {
                state.reports.isFetching = false;
            },
        };
    }
}
